import { ReturnType } from './return-type.enum';

export class CalculationExpression {
  constructor(
    public value: string,
    public type: ReturnType
  ) { }
}
